/*
*  This mixin make elements(.item-info) of equal width
*  wrapperComponent is a element where .item-info inside
*/

import throttle from 'lodash/throttle';

export default {
    data: () => ({
        elements: []
    }),
    methods: {
        alignElements() {
            if (this.alignedElement) {
                this.elements = [
                    ...Array.from(document.querySelectorAll(`${this.wrapperComponent ? this.wrapperComponent : ''} .item-info`)),
                    ...Array.from(document.querySelectorAll(`${this.wrapperComponent ? this.wrapperComponent : ''} ${this.alignedElement}`))
                ]
            } else {
                this.elements = document.querySelectorAll(`${this.wrapperComponent ? this.wrapperComponent : ''} .item-info`)
            }
            this.elements.forEach(element => element.style.width = 'auto');
            const elementsWidth = Array.from(this.elements).map(o => o.getBoundingClientRect().width)
            const elementMaxWidth = Math.ceil(Math.max(...elementsWidth))
            this.elements.forEach(element => element.style.width = `${elementMaxWidth + 1}px`);
        },
        throttledAlignElements: throttle(function() {
            this.alignElements()
        }, 300)
    },
    mounted() {
        this.$nextTick(() => this.alignElements())
    },
    created() {
        window.addEventListener('resize', this.throttledAlignElements);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.throttledAlignElements);
    }
}
